module.exports = __webpack_public_path__ + "img/card-dress.4b797354.png";